import { Repository } from "../../adapters/repository";
import { validateAccountCreationConfirmationRequest } from "../../entities/accountCreationConfirmationValidator";
import { findError } from "../../../entities/errorChecker";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";
import { Account, Identifiable, Planzone } from "@planzone/dto";

function createInteractor(repository: Repository): Interactor {
  return (request) => {
    const error = validateAccountCreationConfirmationRequest(request);

    return present(
      !findError(error)
        ? repository
            .confirmAccountCreation(request)
            .then((account) =>
              request.hasRequestedPlanzoneCreation
                ? repository
                    .savePlanzone(
                      request.planzone.name,
                      request.planzone.domain,
                    )
                    .then((planzone) => ({ planzone, account }))
                : { account },
            )
            .then(
              ({
                planzone,
                account,
              }: {
                account: Identifiable<Account>;
                planzone?: Identifiable<Planzone>;
              }) => ({
                account,
                request,
                planzone,
              }),
            )
            .catch((e) =>
              Promise.reject({ error: { ...error, ...e }, request }),
            )
        : Promise.reject({ error, request }),
    );
  };
}

export type { Interactor };

export { createInteractor };
